import EventEmitter from "eventemitter3";

export const tooManyRequestEventEmitter = new EventEmitter();

export const tooManyRequestId = "too-many-request";

export const onTooManyRequest = () => {
  tooManyRequestEventEmitter.emit(tooManyRequestId);
};
